import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ProductoRenovacion } from '../_models/producto-renovacion';

@Injectable({
  providedIn: 'root'
})
export class ProductoRenovacionService {
  private rutServicio = AppSettings.rutServiciosAPL + '/api/productosRenovaciones';

  constructor( private httClient: HttpClient, private autServicio: AutenticacionService ) {
  }

  listado() {
    return this.httClient.get( this.rutServicio ).pipe( map( res => res as ProductoRenovacion[] ) );
  }

  listadoHabilitados() {
    return this.httClient.get( this.rutServicio + '/enabled' ).pipe( map( res => res as ProductoRenovacion[] ) );
  }

  listadoPorProducto( idProducto: string ) {
    return this.httClient.get( this.rutServicio + '/producto/' + idProducto ).pipe( map( res => res as ProductoRenovacion[] ) );
  }

  obtenerPorId( id: string ) {
    return this.httClient.get( this.rutServicio + '/' + id ).pipe( map( res => res as ProductoRenovacion ) );
  }

  crear( regCrear: ProductoRenovacion ) {
    regCrear.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.post( this.rutServicio, regCrear ).pipe( map( res => res as ProductoRenovacion ) );
  }

  actualizar( regActualizar: ProductoRenovacion ) {
    regActualizar.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.httClient.put( this.rutServicio, regActualizar ).pipe( map( res => res as any ) );
  }

}
